import React from "react";
import { MenuItem } from "@material-ui/core";

import { Popup, PopupContent } from "js/Components/Popup";
import { formatter } from "js/core/utilities/formatter";
import { AiGeneratedSlideGroupType } from "common/aiConstants";

import { PopupContainerStyles } from "./PaneComponents";

function formatSlideGroupType(type: AiGeneratedSlideGroupType) {
    return type === AiGeneratedSlideGroupType.ALL_BUT_TITLE_AND_CONCLUSION ? "Auto" : formatter.capitalizeFirstLetter(type);
}

export default function SlideGroupTypesPopup(props: {
    allowedSlideGroupTypes: AiGeneratedSlideGroupType[],
    slideGroupType: AiGeneratedSlideGroupType,
    onSlideGroupTypeChange: (slideGroupType: AiGeneratedSlideGroupType) => void
}) {
    const { allowedSlideGroupTypes, slideGroupType, onSlideGroupTypeChange } = props;

    return (
        <Popup
            value={slideGroupType}
            label={formatSlideGroupType(slideGroupType)}
            contained showArrow disableHoverState
            overrideContainerStyles={PopupContainerStyles}
        >
            <PopupContent>
                {closePopup => (
                    <PopupContent>
                        {allowedSlideGroupTypes.map((type, idx) => (
                            <MenuItem key={idx} value={type} onClick={() => {
                                onSlideGroupTypeChange(type);
                                closePopup();
                            }}>
                                {formatSlideGroupType(type)}
                            </MenuItem>
                        ))}
                    </PopupContent>
                )}
            </PopupContent>
        </Popup>
    );
}
